import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gavel, CheckCircle2 } from "lucide-react";
import { endpoints, api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function JudgeRunSheet() {
  const { user, hasRole, login } = useAuth();
  const [cars, setCars] = useState([]);
  const [scores, setScores] = useState({});
  useEffect(() => {
    endpoints.cars().then(setCars).catch(() => {});
    if (user && hasRole("judge")) api.get("/my-scores").then((r) => setScores(r.data)).catch(() => {});
  }, [user]);

  if (!user) return <div className="text-center py-20"><button onClick={login} className="pas-btn">Sign in</button></div>;
  if (!hasRole("judge")) return <div className="text-center py-20 text-[#8a8d91] font-heading uppercase">Judges only</div>;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Gavel className="text-[#b026ff]" size={24} />
        <h1 className="font-display text-4xl uppercase text-white">Judge Run Sheet</h1>
      </div>
      <p className="text-[#8a8d91] font-body text-sm">Score each car on design, engineering, finish and wow factor. Out of 40.</p>
      <div className="space-y-2" data-testid="judge-runsheet">
        {cars.map((c) => {
          const s = scores[c.id];
          return (
            <Link key={c.id} to={`/app/cars/${c.id}`} className="flex items-center gap-3 border border-white/10 bg-[#121212] card-hover overflow-hidden" data-testid={`judge-car-${c.id}`}>
              <img src={c.photo_url} alt="" className="w-20 h-16 object-cover" />
              <div className="flex-1 py-2">
                <div className="text-[#ff7a1a] font-heading text-xs uppercase">{c.category_name}</div>
                <div className="font-heading text-white uppercase leading-tight">{c.make} {c.model}</div>
              </div>
              <div className="pr-4 text-right">
                {s ? <div className="text-[#ffd600] font-display text-2xl flex items-center gap-1"><CheckCircle2 size={16} /> {s.total}</div>
                  : <span className="text-[#8a8d91] font-heading uppercase text-xs">Score</span>}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
